<div [ngClass]="{'isMobile': isMobile}"
  class="app_container vh-100-h w-100 d-flex flex-column flex-md-row align-items-start">
  <!-- SIDE BAR -->
  <div #sidebar
    (mouseleave)="displaySidebar('hide')"
    (mouseover)="displaySidebar('show', $event.target)" [ngClass]="{'isDisplayed':status == 'show', 'd-none': !isDisplayed}"
    class="sidebar h-100 p-4 d-flex flex-column justify-content-between overflow-hidden flex-shrink-0 position-relative bg-sidebar">

    <div class="header-logo pointer w-fit-content d-none d-md-block" [routerLink]="['/' + currentLanguage + '/discover']">
      <img src="../../../../assets/img/logo/LF_logo-mark.svg" alt="" class="small-logo position-absolute">
      <img src="../../../../assets/img/logo/LF_logo-horizontal.svg" alt="" class="large-logo position-absolute">
    </div>

    <!-- ONLINE USER -->
    <div class="link_container fw-light" *ngIf="currentUser && isBrowser">
      <!-- ADMIN MENU -->
      <div class="link_container" *ngIf="currentUser && currentUser['isGhost'] && isAdminPanel">
        <div class="d-flex flex-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative" [ngClass]="{'pointer-ev-none opa-50': item.disabled}"
             *ngFor="let item of adminMenu" mat-list-item
             routerLinkActive="active-list-item fw-bold text-primary" routerLink="{{item.link}}">
          <mat-icon class="font-24">{{ item.icone }}</mat-icon>
          <div class="text-nowrap">{{ item.name }}</div>
        </div>
        <div class="d-flex flex-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative"
             (click)="goToDashboard()">
          <mat-icon class="font-24">chrome_reader_mode</mat-icon>
          <div class="text-nowrap">Dashboard</div>
        </div>
      </div>

      <!-- USER MENU  -->
      <div class="link_container  align-items-center align-items-md-start" *ngIf="!currentUser['isGhost'] || (currentUser['isGhost'] && !isAdminPanel)">
        <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-flex flex-column flex-md-row py-2 pointer my-md-3 w-fit-content side-links lightGray2 position-relative align-items-center align-items-md-start"
          routerLinkActive="active-list-item fw-bold text-primary" [routerLink]="['/' + currentLanguage + '/discover']" mat-list-item>
          <mat-icon class="font-24">dashboard</mat-icon>
          <div class="text-nowrap">{{ (isMobile ? 'MOBILE.' : '') + "MENU.SERVICES.TITLE" | translate }}</div>
        </div>
        <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-flex flex-column flex-md-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative  align-items-center align-items-md-start"
             routerLinkActive="active-list-item fw-bold text-primary" [routerLink]="['/account/school']" mat-list-item *ngIf="school && school.slug != 'livinfrance' && school.slug != 'harvard' && (school.description || school.description_fr)">
          <mat-icon>school</mat-icon>
          <div class="text-nowrap">{{ (isMobile ? 'MOBILE.' : '') + "MENU.SCHOOL.TITLE" | translate }}</div>
        </div>
        <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-flex flex-column flex-md-row py-2 pointer my-md-3 w-fit-content side-links lightGray2 position-relative align-items-center align-items-md-start"
          mat-list-item (click)="open(content)">
          <mat-icon class="font-24">language</mat-icon>
          <div class="text-nowrap">{{ (isMobile ? 'MOBILE.' : '') + "MENU.LANGUAGE.TITLE" | translate }}</div>
        </div>
        <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-flex flex-column flex-md-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative  align-items-center align-items-md-start"
          routerLinkActive="active-list-item fw-bold text-primary" mat-list-item [routerLink]="['/account/my-profile']">
          <mat-icon>account_box</mat-icon>
          <div class="text-nowrap">{{ (isMobile ? 'MOBILE.' : '') + "MENU.PERSONAL-SPACE.TITLE" | translate }}</div>
          <span *ngIf="currentUser.notifications && currentUser.notifications.length > 0" class="red-pastille"></span>
        </div>

        <a role="button" [href]="contactFormUrl" target="_blank" rel="noopener noreferrer" (mouseenter)="displaySidebar('show',{className : 'sidebar'})" *ngIf="!isMobile"
          class="d-none d-md-flex py-2 pointer my-3 w-fit-content side-links lightGray2 align-items-md-start text-decoration-none">
          <lf-icon class="sidenav_img" name="chatIcon" height="20px" width="24px"></lf-icon>
          <div class="ps-2">{{ 'MENU.CONTACT_FORM' | translate }}</div>
        </a>
      </div>
      <!-- IF ADMIN & NOT IN ADMIN -->
      <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-flex flex-column flex-md-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative  align-items-center align-items-md-start"
           routerLinkActive="active-list-item fw-bold text-primary" [routerLink]="'/admin/home'" mat-list-item *ngIf="currentUser['isGhost'] && !isAdminPanel">
        <mat-icon class="font-24">chrome_reader_mode</mat-icon>
        <div class="text-nowrap">Administration</div>
      </div>
      <!-- EVERY ONLINE USER -->
      <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-none d-md-flex flex-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative  align-items-center align-items-md-start" *ngIf="!isMobile"
           (click)="logout()">
        <mat-icon class="font-24">exit_to_app</mat-icon>
        <div class="text-nowrap"> {{ "MENU.LOGOUT.TITLE" | translate }}</div>
      </div>
    </div>

    <!-- IF NOT LOGGED USER -->
    <div class="link_container" *ngIf="!currentUser && isBrowser">
      <div class="d-flex flex-column flex-md-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative pointer"
           routerLinkActive="active-list-item fw-bold text-primary" (click)="redirectToLogin()" mat-list-item>
        <mat-icon class="font-24">person_add</mat-icon>
        <div class="text-nowrap">{{ "COMMON.SIGN_IN" | translate }}/{{ "COMMON.LOGIN" | translate }}</div>
      </div>

      <div (mouseenter)="displaySidebar('show',{className : 'sidebar'})" class="d-flex flex-column flex-md-row py-2 pointer my-3 w-fit-content side-links lightGray2 position-relative align-items-center align-items-md-start" mat-list-item (click)="open(content)">
        <mat-icon class="font-24">language</mat-icon>
        <div class="text-nowrap">{{ (isMobile ? 'MOBILE.' : '') + "MENU.LANGUAGE.TITLE" | translate }}</div>
      </div>

    </div>

    <div class="font-12 fw-bold text-center lightGray2 d-none d-md-block" [ngClass]="{'smaller': currentUser && currentUser.isGhost}">
      <div class="school-logo mb-3 bg-light br-8 text-start ps-4" *ngIf="currentUser && school && !isAdminPanel && school.name.toLowerCase() !== 'livinfrance'">
        <div class="font-16 fw-normal d-flex align-items-end position-relative mb-3 text-nowrap lf-after-bg">{{ 'COMMON.PARTNER_WITH' | translate }}</div>
        <img src="{{ mediaPath + school.logo }}" alt="" class="w-auto">
      </div>
      v2.7.9.5
    </div>


  </div>

  <!-- PAGE CONTAINER -->
  <div id="sidenav-page_content" #pageContent *ngIf="!loading && school"
    [ngClass]="{'my-0': isMobile, 'sidebarHovered':status == 'show', 'mb-0': !hasBottomMargin, 'page_content': isNotProperty}"
    [ngStyle]="{'margin.px': marginPx}"
    class="flex-grow-1 align-self-stretch hidden-scrollbar  order-first order-md-0 page_listener">
    <alert></alert>
    <router-outlet></router-outlet>
  </div>

  <!-- MODAL LANGUAGE -->
  <ng-template #content let-modal>
    <div class="d-flex px-5 justify-content-center gap-24 pt-4 align-items-center">
      <h5 class="modal-title text-center" id="modal-basic-title">
        {{ "MENU.LANGUAGE.MODAL_TITLE" | translate }}
      </h5>
      <button type="button" class="btn border-0 m-0 p-0 d-flex" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>
    <div class="px-5 py-4 d-flex align-items-center justify-content-center custom-gap">
      <button *ngFor="let language of ['fr', 'en']" class="btn d-flex gap-8 align-items-center " (click)="useLanguage(language)">
        <span class="d-block lang-box rounded-pill" [style.background-image]="'url(\'/assets/img/' + language  + '.svg\')'"></span>
        {{ getLanguageKey(language) | translate }}
      </button>
    </div>
  </ng-template>

</div>
